(function () {
  const METAL_CLASSES = ['metal-or', 'metal-argent'];

  function getMetalClassFromVariant(variant) {
    if (!variant) return 'metal-or';

    const options = [variant.option1, variant.option2, variant.option3].filter(Boolean);

    for (const option of options) {
      const value = option.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      if (value.includes('argent') || value.includes('silver')) {
        return 'metal-argent';
      }
    }

    return 'metal-or';
  }

  function applyMetalTheme(metalClass) {
    const html = document.documentElement;
    html.classList.remove(...METAL_CLASSES);
    html.classList.add(metalClass);
  }

  function init() {
    const variantData = document.querySelector('variant-selects [data-selected-variant]');

    if (variantData) {
      try {
        applyMetalTheme(getMetalClassFromVariant(JSON.parse(variantData.textContent)));
      } catch (error) {
        console.error('variant-metal-theme: unable to parse variant data', error);
      }
    }

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
      applyMetalTheme(getMetalClassFromVariant(variant));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
